export var isClient = typeof window !== 'undefined'; //eslint-disable-line